import { useComponentConfig } from '@namespace/cms';
import { LOBBY_RECOMMENDED_GAMES_AMOUNT } from '../../constants';
import { useCasinoSettings, useGetFeedName } from '../../hooks';
import { useRecommendedGamesCategory } from '../../store';

export const useRecommendedGamesCasinoSearch = () => {
  const casinoGamesSearchConfig = useComponentConfig();
  const { casinoType, showRecommendedCategory } = casinoGamesSearchConfig;
  const feedName = useGetFeedName(casinoType);
  const { suggesterServiceEntityName } = useCasinoSettings(casinoType);

  const recommendedCategory = useRecommendedGamesCategory({
    feedName,
    suggesterServiceEntityName,
    showRecommendedCategory,
    maxGamesAmount: LOBBY_RECOMMENDED_GAMES_AMOUNT,
    isViewAllEnabled: false
  });

  return recommendedCategory?.categoryGames?.length
    ? recommendedCategory
    : null;
};
